import { UseQueryOptionsWithoutQueryKey } from '../../react-query-config'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { useQuery } from '@tanstack/react-query'
import { ResponseApiError } from '../../models/axios-error'

export type Instore = {
  target_gmv: number | null
  target_gmv_progression: number | null
  target_margin_rate: number | null
  target_margin_rate_progression: number | null
  target_selling_price: number | null
  target_selling_price_progression: number | null
  target_quantity: number | null
  target_quantity_progression: number | null
  channels: {
    target_physical_gmv: number | null
    target_digital_gmv: number | null
    target_decapro_gmv: number | null
  }
  economies: {
    target_circular: number | null
    target_non_circular: number | null
  }
  circular_economy: {
    target_repair: number | null
    target_second_life: number | null
    target_rental: number | null
    target_buy_back: number | null
  }
}

export type Outstore = {
  target_gmv: number | null
  target_gmv_progression: number | null
  target_margin_rate: number | null
  target_margin_rate_progression: number | null
  target_selling_price: number | null
  target_selling_price_progression: number | null
  target_quantity: number | null
  target_quantity_progression: number | null
}

export type Omni = {
  target_gmv: number | null
  target_gmv_progression: number | null
  target_margin_rate: number | null
  target_margin_rate_progression: number | null
  target_selling_price: number | null
  target_selling_price_progression: number | null
  target_quantity: number | null
  target_quantity_progression: number | null
}

export type StoreTrajectory = {
  instore: Instore
  outstore: Outstore
  omni: Omni
  last_update_uid: string | null
  last_update_date: string | null
}

const getStoreTrajectory = async (config: AxiosRequestConfig): Promise<StoreTrajectory> => {
  const axiosPromise: AxiosResponse<StoreTrajectory> = await axios(config)
  return {
    ...axiosPromise.data
  }
}

export const useApiGetStoreTrajectory = (
  storeId: number,
  year: number,
  enabled: boolean,
  options?: UseQueryOptionsWithoutQueryKey<StoreTrajectory>
) => {
  const url = `/v1/stores/${storeId}/trajectories/year/${year}`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<StoreTrajectory, ResponseApiError>({
    queryKey: ['get-store-trajectory', url],
    queryFn: () => getStoreTrajectory(config),
    enabled,
    ...options
  })
}
